import { UserName } from "../Users/shared/UserName.js";
import { LocationName } from "../Locations/shared/LocationName.js";
import { EventName } from "../Events/shared/EventName.js";
import { LocationLogEntryTitle } from "../Locations/shared/LocationLogEntries/LocationLogEntryTitle.js";
import { RecordTitle } from "../Records/shared/RecordTitle.js";
import { ReportTitle } from "../Reports/shared/ReportTitle.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/shared/RefLinkRefLabel.tsx
var TYPE_COMPONENTS = {
	event: (id) => /* @__PURE__ */ jsx(EventName, {
		id,
		showId: true
	}, id),
	location: (id) => /* @__PURE__ */ jsx(LocationName, {
		showId: true,
		locationId: id
	}, id),
	["location-log-entry"]: (id) => /* @__PURE__ */ jsx(LocationLogEntryTitle, {
		id,
		showId: true
	}, id),
	record: (id) => /* @__PURE__ */ jsx(RecordTitle, {
		id,
		showId: true
	}, id),
	report: (id) => /* @__PURE__ */ jsx(ReportTitle, {
		id,
		showId: true
	}, id),
	user: (id) => /* @__PURE__ */ jsx(UserName, {
		userId: id,
		showId: true
	}, id)
};
/**
* A component that renders an inline text label for a ref link.
*/
var RefLinkRefLabel = ({ type, value }) => {
	if (!TYPE_COMPONENTS[type]) return null;
	return TYPE_COMPONENTS[type](value);
};
//#endregion
export { RefLinkRefLabel };

//# sourceMappingURL=RefLinkRefLabel.js.map